import AddIcon from "@material-ui/icons/Add";
import DescriptionIcon from "@material-ui/icons/Description";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import React, { FC, useState } from "react";
import { useHistory } from "react-router-dom";

import BaseDataTable from "../../../../components/modules/BaseDataTable";
import Button from "../../../../components/elements/Button";
import CreateAdvertiserModal from "../../../../components/Advertisers/CreateAdvertiserModal";
import classes from "./AdvertisersDashboard.module.scss";
import { AdvertiserType } from "../../../../types/advertiserTypes";
import { truncateText } from "../../../../helpers/truncateText";

type AdvertisersDashboardProps = {
  advertisers: AdvertiserType[];
};

const AdvertisersDashboard: FC<AdvertisersDashboardProps> = ({ advertisers }) => {
  const history = useHistory();

  const [isCreateAdvertiserModalOpen, setIsCreateAdvertiserModalOpen] = useState(false);

  const handleOpenCreateAdvertiserModal = () => {
    setIsCreateAdvertiserModalOpen(true);
  };

  const handleCloseCreateAdvertiserModal = () => {
    setIsCreateAdvertiserModalOpen(false);
  };

  const handleNavigateToAdvertiserDetailPage = (id: string) => () => {
    history.push(`/advertisers/${id}`);
  };

  const columns = [
    { key: "name", label: "Name", minWidth: 170 },
    { key: "createdBy", label: "Created by", minWidth: 150 },
    {
      key: "createdDate",
      label: "Created Date",
      minWidth: 120,
    },
    {
      key: "creditCard",
      label: "Credit Card",
      minWidth: 100,
    },
    {
      key: "actions",
      label: "Actions",
      minWidth: 100,
    },
  ] as const;

  const rows = advertisers
    .sort((a, b) => Date.parse(b.createdAt!) - Date.parse(a.createdAt!))
    .map(({ brandgenAdvertiserId, name, createdBy, createdAt, paymentMethod }) => ({
      id: brandgenAdvertiserId,
      name: (() => (
        <Tooltip title={name}>
          <Typography>{truncateText(name, 36)}</Typography>
        </Tooltip>
      ))(),
      createdBy: (() => (
        <Tooltip title={createdBy}>
          <Typography>{truncateText(createdBy, 36)}</Typography>
        </Tooltip>
      ))(),
      createdDate: createdAt ? new Date(createdAt).toLocaleDateString() : "",
      creditCard: paymentMethod?.card.last4 ? (
        <Typography>* * * * {paymentMethod?.card.last4}</Typography>
      ) : (
        <Typography className={classes.dangerText}>No Card</Typography>
      ),
      actions: (() => (
        <Button
          onClick={handleNavigateToAdvertiserDetailPage(brandgenAdvertiserId)}
          variant="outlined"
          className={classes.detailsButton}
        >
          Details <DescriptionIcon />
        </Button>
      ))(),
    }));

  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <div className={classes.dashboardContainer}>
          <div className={classes.dashboardControls}>
            <Typography>Advertisers associated with your account</Typography>

            <Button onClick={handleOpenCreateAdvertiserModal}>
              Create New Advertiser <AddIcon />
            </Button>
          </div>
          <CreateAdvertiserModal isOpen={isCreateAdvertiserModalOpen} handleClose={handleCloseCreateAdvertiserModal} />

          <div className={classes.dashboard}>
            <BaseDataTable columns={columns} rows={rows} />{" "}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdvertisersDashboard;
